import { CONFIG } from "../../config";
import { getTokenizedAxios } from "../../utils/axiosWithTokenGen";
import {
  CreateBannerRequestBody,
  CreateBannerResponse,
  DeleteBannerPath,
  DeleteBannerResponse,
  GetBannersQuery,
  GetBannersResponse,
  TranslateBannerRequestBody,
  TranslateBannerResponse,
  UpdateBannerPath,
  UpdateBannerRequestBody,
  UpdateBannerResponse,
} from "../../interfaces/banner.interface";

const BASE = "/banners";

export async function listBanners(params: GetBannersQuery) {
  const axios = await getTokenizedAxios();
  return axios
    .get<GetBannersResponse>(CONFIG.BANNERS_SERVER.BASE_URL + BASE, { params })
    .then((res) => res.data);
}

export async function createBanner(body: CreateBannerRequestBody) {
  const axios = await getTokenizedAxios();
  return axios
    .post<CreateBannerResponse>(CONFIG.BANNERS_SERVER.BASE_URL + BASE, body)
    .then((res) => res.data);
}

export async function updateBanner(
  path: UpdateBannerPath,
  body: UpdateBannerRequestBody
) {
  const axios = await getTokenizedAxios();
  const url = `${CONFIG.BANNERS_SERVER.BASE_URL + BASE}/${path.bannerId}`;
  return axios.put<UpdateBannerResponse>(url, body).then((res) => res.data);
}

export async function deleteBanner(path: DeleteBannerPath) {
  const axios = await getTokenizedAxios();
  const url = `${CONFIG.BANNERS_SERVER.BASE_URL + BASE}/${path.bannerId}`;
  return axios.delete<DeleteBannerResponse>(url).then((res) => res.data);
}

export async function translateBanner(body: TranslateBannerRequestBody) {
  const axios = await getTokenizedAxios();
  return axios
    .post<TranslateBannerResponse>(
      `${CONFIG.BANNERS_SERVER.BASE_URL + BASE}/translate`,
      body
    )
    .then((res) => res.data);
}
